// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.schedule-container {
  overflow-x: auto;
  overflow-y: auto; /* Aktifkan scroll vertikal */
  max-height: 700px; /* Batasi tinggi tabel */
  white-space: nowrap;
  border: 1px solid #ddd; /* Tambahkan border agar lebih jelas */
  position: relative;
  z-index: 1;
  will-change: scroll-position;
  /* Efek shimmer elegan & minimalis (Modern UI Skeleton Loader) */
  background-color: #f5f6f8;
  background-image: linear-gradient(110deg, #f5f6f8 30%, #ffffff 50%, #f5f6f8 70%);
  background-repeat: repeat;
  background-size: 800px 100%;
  animation: shimmerEffect 1.5s infinite linear;
}

@keyframes shimmerEffect {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 800px 0;
  }
}
table {
  border-collapse: collapse;
  width: max-content; /* Agar lebar menyesuaikan jumlah kolom */
}

thead {
  position: sticky;
  top: 0;
  background: white;
  z-index: 100;
}

th,
td {
  border: 1px solid #ddd;
  text-align: center;
  padding: 5px;
  white-space: nowrap;
  min-width: 50px;
}

.time-header {
  background: #f1f1f1;
  font-weight: bold;
  min-width: 30px;
  position: sticky;
  top: 0;
  z-index: 150;
}

.time-subheader {
  background: #e0e0e0;
  font-size: 12px;
  min-width: 30px;
  position: sticky;
  top: 40px; /* Agar tetap berada di bawah header utama */
  z-index: 140;
}

.bg-scheduled {
  background-color: rgb(227, 172, 63);
}

.bg-unscheduled {
  background-color: #fff;
}

.sticky-name {
  position: sticky;
  left: 0;
  background: #f5f5f5;
  z-index: 200;
  border-right: 1px solid #ddd;
  min-width: 220px;
  width: 220px;
  max-width: 240px;
  padding: 8px 10px;
  box-sizing: border-box;
  white-space: normal !important;
  vertical-align: top;
}

.date-header {
  border-bottom: 2px solid #ccc;
  border-right: 1px solid #ddd;
  background: #f8f8f8;
  font-weight: bold;
  text-align: left;
  padding: 6px 8px;
  position: sticky;
  top: 0;
  z-index: 150;
}
.date-header .sticky-date-wrapper {
  position: sticky;
  left: 228px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  color: #1e293b;
  padding: 4px 14px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 13px;
  font-weight: 600;
  margin-left: 4px;
  white-space: nowrap;
  z-index: 160;
}
.date-header .sticky-date-wrapper i {
  color: #3b82f6;
  font-size: 14px;
}

.th-empty {
  left: 0;
  position: sticky;
  background: #f5f5f5;
  z-index: 210;
  border-right: 1px solid #ddd;
  min-width: 220px;
  width: 220px;
  max-width: 240px;
}

.schedule-info {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  text-align: center;
  gap: 4px;
}

.schedule-cell {
  position: relative;
  padding: 10px;
  text-align: center;
  cursor: default;
}
.schedule-cell.has-schedule {
  cursor: pointer;
}

/* Pastikan parent memiliki posisi relatif */
.tooltip-container {
  position: relative;
  display: flow; /* Sesuai dengan konten */
}

.tooltip-container:hover .custom-tooltip {
  opacity: 1;
  visibility: visible;
}

.group-name {
  font-weight: 600;
  font-size: 0.85rem;
  color: #1e293b;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.3;
}

.group-light {
  font-weight: normal;
  font-size: 0.75rem;
  color: #64748b;
  text-align: left;
  margin-top: 3px;
  white-space: normal;
}

.schedule-cell {
  padding: 10px;
  text-align: center;
  position: relative;
  font-size: 14px;
  border: 1px solid #ddd;
}

.schedule-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  cursor: pointer;
  padding: 5px;
}

.custom-tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
}

.schedule-content:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

.p-dialog {
  position: fixed !important;
  z-index: 10050 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.p-dialog-mask {
  z-index: 10049 !important;
  background: rgba(0, 0, 0, 0.5) !important; /* Overlay gelap */
}

.tooltip-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
}

.tooltip-btn {
  padding: 6px 10px;
  font-size: 12px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
}

.unschedule-btn {
  background: #ff4d4d;
  color: white;
}

.unschedule-btn:hover {
  background: #e60000;
}

.view-wo-btn {
  background: #007bff;
  color: white;
}

.view-wo-btn:hover {
  background: #0056b3;
}

.swal-confirm-button {
  background-color: red !important; /* 🔹 Ubah warna tombol konfirmasi */
}

.swal-cancel-button {
  background-color: gray !important; /* 🔹 Ubah warna tombol cancel */
}

.schedule-cell:not(.has-schedule) {
  background-image: repeating-linear-gradient(to right, transparent, transparent 50px, #f0f0f0 50px, #f0f0f0 51px);
  background-size: 51px 100%;
}

.sticky-name-content {
  position: sticky;
  top: 100px;
  background: inherit;
  z-index: 201;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
